import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { themed } from '@indeed/ifl-css';
import { keyframes, jsx } from '@emotion/react';
import useResponsiveValue from '../../hooks/useResponsiveValue.js';
import { Flex } from '../Flex/Flex.js';
import '../../hooks/useBreakpointIndex.js';

const sizeVariants = {
  md: {
    blockSize: "3.438rem"
  },
  sm: {
    blockSize: "1.875rem"
  }
};
const alignmentStyles = {
  left: {
    alignSelf: "flex-start"
  },
  right: {
    alignSelf: "flex-end"
  },
  center: {
    alignSelf: "center"
  },
  justify: {
    alignSelf: "flex-start"
  }
};
const skeletonVariants = (size, align, width) => ({
  heading: {
    ...sizeVariants[size],
    ...alignmentStyles[align]
  },
  text: {
    ...alignmentStyles[align],
    inlineSize: `${width}`
  },
  circle: {
    borderRadius: "50%",
    flex: 1,
    blockSize: "6.25rem",
    inlineSize: "6.25rem"
  },
  square: {
    blockSize: "6.25rem",
    inlineSize: "6.25rem"
  }
});
const animationSpeeds = {
  snappy: "0.5s",
  quick: "1s",
  normal: "1.5s",
  slow: "2s",
  slowest: "2.5s"
};
const defaultWidths = [97, 100, 94, 90, 98, 95, 98, 40];
const skeletonKeyframes = width => keyframes`
  0% { transform: translate(-${width}); }
  60% { transform: translate(${width}); }
  100% { transform: translate(${width}); }
`;
const baseStyles = () => ({
  position: "relative",
  bg: "background.strong",
  lineHeight: "normal",
  overflow: "hidden",
  transform: "translate3d(0,0,0)",
  backfaceVisibility: "hidden",
  borderRadius: "sm",
  display: "block",
  inlineSize: "100%"
});
const propStyles = _ref => {
  let {
    align,
    size,
    speed,
    variant,
    width = "100%"
  } = _ref;
  return {
    // @ts-ignore
    ...skeletonVariants(size, align, width)[variant],
    "&::after": {
      content: "' '",
      position: "absolute",
      bottom: 0,
      right: 0,
      left: 0,
      top: 0,
      backgroundImage: "skeleton.gradient",
      animation: `${skeletonKeyframes(width)} ${speed} linear infinite`,
      "@media (prefers-reduced-motion: reduce)": {
        animationDuration: "8s"
      }
    }
  };
};
const rejectedSkeletonAttribute = new Set(["align", "size", "speed", "variant", "width"]);
const StyledSkeleton = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["align", "size", "speed", "variant", "width"],
  shouldForwardProp: prop => !rejectedSkeletonAttribute.has(prop),
  target: "eibgs5u0"
} : {
  styleProps: ["align", "size", "speed", "variant", "width"],
  shouldForwardProp: prop => !rejectedSkeletonAttribute.has(prop),
  target: "eibgs5u0",
  label: "StyledSkeleton"
})(baseStyles, propStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const getTextWidth = (align, i) => {
  return align === "justify" ? "100%" : `${defaultWidths[(i + defaultWidths.length) % defaultWidths.length]}%`;
};
const Paragraph = _ref2 => {
  let {
    align,
    count,
    speed,
    ...props
  } = _ref2;
  const lines = Array(count).fill(null);
  return jsx(Flex, {
    sx: {
      flexDirection: "column",
      flex: "1",
      minInlineSize: 100,
      "& *:not(:last-child)": {
        marginBlockEnd: 3
      }
    }
  }, lines.map((_, i) => jsx(StyledSkeleton, _extends({
    key: i,
    align: align,
    speed: speed,
    size: "md",
    width: getTextWidth(align, i),
    variant: "text"
  }, props), "\u00A0")));
};

/**
 * @see https://experience.indeed.design/components/ids/skeleton
 */
const Skeleton = _ref3 => {
  let {
    align = "left",
    count = 1,
    size = "md",
    speed = "normal",
    variant = "text",
    ...props
  } = _ref3;
  const alignment = useResponsiveValue(align);
  const lineCount = useResponsiveValue(count);
  const animationSpeed = useResponsiveValue(speed);
  const lineHeight = useResponsiveValue(size);
  const finalSpeed = SKELETON_ANIMATION_SPEEDS.indexOf(animationSpeed) >= 0 ?
  // @ts-ignore
  animationSpeeds[animationSpeed] : animationSpeed;
  return variant === "text" ? jsx(Paragraph, _extends({
    align: alignment,
    count: lineCount,
    speed: finalSpeed
  }, props)) : jsx(StyledSkeleton, _extends({
    align: alignment,
    size: lineHeight,
    speed: finalSpeed,
    variant: variant
  }, props), "\u00A0");
};
const SKELETON_ALIGNMENT = Object.keys(alignmentStyles);
const SKELETON_ANIMATION_SPEEDS = ["snappy", "quick", "normal", "slow", "slowest"];
const SKELETON_SIZE = Object.keys(sizeVariants);
const SKELETON_VARIANTS = ["circle", "heading", "square", "text"];
Skeleton.displayName = "Skeleton";

export { SKELETON_ALIGNMENT, SKELETON_ANIMATION_SPEEDS, SKELETON_SIZE, SKELETON_VARIANTS, Skeleton, StyledSkeleton, skeletonKeyframes, skeletonVariants };
